document.addEventListener('alpine:init', () => {
  function predictiveSearchForm(data = {}) {
    return {
      ...data,

      isLoading: false,

      isOpen: false,

      isRendered: false,

      submit() {
        if (this.isLoading) return;

        if (!this.q) {
          return this.isOpen = this.isRendered = false;
        }

        this.isLoading = true;

        var url = new URL(location);

        url.pathname = window.global.routes.predictive_search_url;
        url.search = '';
        url.hash = '';

        url.searchParams.set('q', this.q);
        url.searchParams.set('section_id', this.sectionId);
  
        var fetchOptions = {
          method: this.$el.method,
          body: this.formData
        };

        fetch(url, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            this.$dispatch('predictivesearchformsubmit', { html: res });
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

      render(event) {
        if (!this.$root.checkVisibility()) return;

        this.$el.innerHTML = event.detail.html;
        this.isOpen = this.isRendered = true;

        if (this.scrollToTop) {
          window.scrollTo({ top: 0 });
        }
      },

      onFocusInput() {
        if (!this.isOpen && this.isRendered) {
          this.isOpen = true;
        }
      },

      onClickInput() {
        if (this.scrollToTop) {
          window.scrollTo({ top: 0 });
        }
      },

      onClickReset() {
        this.q = '';
        this.submit();
      },

      toggle() {
        this.isOpen = !this.isOpen;
      }
    };
  };

  Alpine.data('predictiveSearchForm', predictiveSearchForm);
});
